import * as sentry from "@sentry/react";

const trackFBAnalytics = (
  eventName: string,
  data?: Record<string, unknown>,
) => {
  try {
    if (
      typeof window !== "undefined" &&
      typeof (window as any).fbq === "function"
    ) {
      (window as any).fbq("track", eventName, data);
    } else {
      console.warn("Facebook Analytics is not available.");
    }
  } catch (e) {
    console.warn(`Error in trackFBAnalytics: ${eventName}`, e);
    sentry.captureException(e);
  }
};

export const fbCompleteRegistration = () => {
  trackFBAnalytics("CompleteRegistration");
  trackFBAnalytics("SignUp");
};

export default trackFBAnalytics;
